export const model = {
  id: null,
  device_type_name: '',
  created_at: '',
  updated_at: '',
};
